import { resolveOfferHeaderBannerSrc } from '@/utils/offer-template-editor'
import sattvaDefaultLogo from '@/assets/images/logo/logo.svg'
import sattvaWatermarkMark from '@/assets/images/logo/logo-icon.svg'

export function buildAutoSiteName(siteCode, client) {
  const code = String(siteCode || '').trim()
  const clientName = String(client || '').trim()
  if (code && clientName) return `${code} - ${clientName}`
  return code || clientName || ''
}

function brandingAssetSrc(value) {
  if (typeof value === 'string' && value.trim()) return value.trim()
  if (value && typeof value === 'object') {
    const nested = value.default || value.src || value.url || ''
    if (typeof nested === 'string' && nested.trim()) return nested.trim()
  }
  return ''
}

/**
 * Hardcoded Sattva offer branding — existing product assets, not a new brand.
 * Header: two-tone navy (#1A1F5E) + teal (#1EB496) letterhead already used
 *   by resolveOfferHeaderBannerSrc / offer chrome.
 * Logo: bundled wordmark used app-wide (nav + invoice letterhead).
 * Watermark: bundled icon-only diamond (same invoice watermark mark).
 * Signature/stamp stays empty — that is per-template, not chrome.
 */
export function defaultOfferBrandingImages() {
  return {
    header: resolveOfferHeaderBannerSrc(''),
    logo: brandingAssetSrc(sattvaDefaultLogo),
    watermark: brandingAssetSrc(sattvaWatermarkMark),
    signature: '',
  }
}

/** Fill missing branding fields only — never overwrite a saved custom value. */
export function withDefaultOfferBranding(images = {}) {
  const defaults = defaultOfferBrandingImages()
  const current = images && typeof images === 'object' ? images : {}
  const pick = key => brandingAssetSrc(current[key]) || defaults[key]
  return {
    header: pick('header'),
    logo: pick('logo'),
    watermark: pick('watermark'),
    signature: pick('signature'),
  }
}

export function emptyForm() {
  return {
    id: null,
    site_code: '',
    site_name: '',
    client: '',
    project_type: '',
    location: '',
    jobTitle: '',
    is_active: true,
    htmlTemplate: '',
    images: withDefaultOfferBranding(),
  }
}
